import React from "react";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";

export default function Working() {
  return (
    <section className="contacts education">
      <Breadcrumbs />
      <h1 className="contacts__title history__title licenses__title">
        График работы
      </h1>
      <div>
        <h3 className="about-nii__title antiCorruption__title">
          Уважаемые пациенты мы работаем:
        </h3>
        <p className="dissertation__text">
          Понедельник - пятница<br></br>09:00 - 18:00
        </p>
        <p className="dissertation__text">
          Суббота<br></br>09:00 - 14:00
        </p>
      </div>
      <div>
        <h3 className="about-nii__title antiCorruption__title">Телефоны:</h3>

        <p className="dissertation__text">
          Справочное:<br></br> +7 (343) 218-33-75
        </p>
        <p className="dissertation__text">
          Запись к специалистам:<br></br> +7 (343) 218-95-86
        </p>
        <p className="dissertation__text">
          Запись для проведения криодеструкции жидким азотом вирусных бородавок
          (при наличии направления от дерматолога):<br></br>+7 (343) 210-77-20
        </p>
        <p className="dissertation__text">
          По вопросам работы консультативного клинико-диагностического отделения
          и специалистов обращаться к заведующему в кабинет № 5 Скидан Николай
          Иванович<br></br>+7 (343) 218-95-68
        </p>
        <p className="dissertation__text"></p>
        <p className="dissertation__text"></p>
        <p className="dissertation__text"></p>
        <p className="dissertation__text"></p>
        <p className="dissertation__text"></p>
      </div>
    </section>
  );
}
